module.exports = {"440781001":"台城街道","440781100":"大江镇","440781101":"水步镇","440781102":"四九镇","440781103":"白沙镇","440781104":"三合镇","440781105":"冲蒌镇","440781106":"斗山镇","440781107":"都斛镇","440781108":"赤溪镇","440781109":"端芬镇","440781110":"广海镇","440781111":"海宴镇","440781112":"汶村镇","440781113":"深井镇","440781114":"北陡镇","440781115":"川岛镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/440781.json
// module id = 1993
// module chunks = 0